import { CardinalLocal3DEdge } from 'utils/3d-edge-types';
import { EdgeRunType } from 'utils/opening-position-types';

export function local3DEdgeFromRun(
  run: EdgeRunType,
  bboxWidthFeet: number,
  bboxHeightFeet: number,
  scale: number
): CardinalLocal3DEdge {
  const halfWidth = (bboxWidthFeet * scale) / 2;
  const halfDepth = (bboxHeightFeet * scale) / 2;
  return {
    p1: {
      x: run.start.x * scale - halfWidth,
      z: run.start.y * scale - halfDepth
    },
    p2: {
      x: run.end.x * scale - halfWidth,
      z: run.end.y * scale - halfDepth
    },
    lengthFt: run.lengthFt
  };
}
